module.exports = __webpack_public_path__ + "static/media/address.3f85156b.svg";